/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeFromJSON, FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeToJSON, } from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType';
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('LoginCredentialType' in value) || value['LoginCredentialType'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
        'LoginCredentialType': FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeFromJSON(json['LoginCredentialType']),
    };
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
        'LoginCredentialType': FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeToJSON(value['LoginCredentialType']),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataEgsAuthData.js.map